import { LayoutModule } from '../../../layout/modules';
import { SamplesFilters } from './filters';
import { useState } from 'react';
import { SamplesFilter } from '../../../../shared/types/legalProceedings/samples';
import { SamplesList } from './list';

export const Samples = () => {
    const [filters, setFilters] = useState<SamplesFilter>();

    return (
        <>
            <LayoutModule title="Búsqueda de muestras PQR">
                <SamplesFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <SamplesList filters={filters} />
        </>
    );
};
